module.exports = __webpack_public_path__ + "img/00053.94424721.webp";